import { DEFAULT_ERROR_MESSAGE } from '@shared/config';

import type { MediaPromoClipsQuery } from '@shared/api/graphql/generated';

import type { PromoListItem, PromoStatusesInfo, PromoStatus } from './types';

export const getPromoError = (message?: string) => new Error(message || DEFAULT_ERROR_MESSAGE);

export const getPromoStatus = (status: string): PromoStatus => {
  switch (status.toLowerCase()) {
    case 'active':
      return 'active';
    case 'planned':
      return 'planned';
    case 'passed':
      return 'passed';
    default:
      return 'stopped';
  }
};

export const mapPromoClip = (clip: NonNullable<MediaPromoClipsQuery['result']['result']>[number]): PromoListItem => ({
  audioUrl: clip.promo?.uri || null,
  campaignTitle: clip.adcampaignTitle,
  id: clip.id,
  isSelected: clip.isSelected,
  mediafileId: clip.promo?.id || null,
  status: getPromoStatus(clip.adcampaignStatus),
  title: clip.promo?.title || '',
});

export const getPromoStatusesInfo = (
  statusesInfo: MediaPromoClipsQuery['result']['statusesInfo']
): PromoStatusesInfo => ({
  active: statusesInfo?.active || 0,
  planned: statusesInfo?.planned || 0,
  passed: statusesInfo?.passed || 0,
  stopped: statusesInfo?.stopped || 0,
});
